<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'

      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>门店名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

            <!-- <label>商品:</label>
            <lk-input clearable v-model='query.nameMix' class="item" placeholder="商品名称、通用名称、助记码、商品编码"></lk-input> -->
          </div>
          <div class="queryItem">
            <label>商品类型:</label>
            <lk-select v-model='query.goodsType' class="item" clearable>
              <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable>
              <lk-option v-for="(item, index) in getGoodsOrigin" :key="index" :value="item.value">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>规格:</label>
            <lk-input clearable v-model='query.spec' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>生产企业:</label>
            <lk-input clearable v-model='query.producer' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>批准文号/注册证号:</label>
            <lk-input clearable v-model='query.approvalCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>单号:</label>
            <lk-input clearable v-model='query.rejectionCode' class="item" placeholder="请输入"></lk-input>
          </div>
          <div class="queryItem">
            <label>创建时间:</label>
            <timeStampDatePicker  v-model='query.createTimeStart' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.createTimeEnd' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>来源单据:</label>
            <lk-select v-model='query.purchaseRejectionType' class="item">
              <lk-option v-for="(item, index) in type" :key="index" :value="index+1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item">
              <lk-option v-for="(item, index) in isDtpList" :key="index" :value="index + 1">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>储存条件:</label>
            <lk-select v-model='query.storageCondition' class="item">
              <lk-option v-for="(item, index) in storageConditionsList" :key="index" :value="item.dictionaryIndex">{{item.dictionaryName}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.gspIdList' class="item" filterable multiple>
              <lk-option v-for="(item, index) in gspList" :key="index" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear" class="mr">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="mb8">
          <DownloadButton v-if="handlePermission('rejectionStatsDownloadBtn')" @on-click="handleExport"></DownloadButton>
        </div>
        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">拒收数量:</div>
            <div class="Report-total-item-value">{{total.allNumDisplay}}</div>
          </div>
        </div>
        <lk-table border :columns='columns' :data='tableData'></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import goodsService from '../../services/goods';

import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'RejectionStats',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame, DownloadButton,
  },
  computed: {
    // getNormalGoodsTypes() {
    //   return this.$store.state.publicParams.goodsTypes;
    // },
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
  },
  data() {
    return {
      isDtpList: ['是', '否'],
      storageConditionsList: [],
      gspList: [],
      query: {
        storeIdList: [],
        spec: '',
        producer: '',
        approvalCode: '',
        createTimeStart: null,
        createTimeEnd: null,
        rejectionCode: '',
        nameMix: '',
        purchaseRejectionType: '',
        goodsType: '',
        purchaseType: 1,
      },
      type: ['收货单', '验收单'],
      columns: [
        {
          title: '门店名称',
          key: 'storeName',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '拒收日期',
          key: 'createTime',
          tooltip: true,
          minWidth: 144,
        },
        {
          title: '拒收单号',
          key: 'purchaseRejectionCode',
          tooltip: true,
          minWidth: 144,
        },
        {
          title: '拒收类型',
          key: 'typeName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '收货/验收单号',
          key: 'referCode',
          tooltip: true,
          minWidth: 172,
        },
        {
          title: '采购单号',
          key: 'purchaseOrderCode',
          tooltip: true,
          minWidth: 172,
        },
        {
          title: '计划单号',
          key: 'purchasePlanCode',
          tooltip: true,
          minWidth: 172,
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '来源',
          key: 'purchaseTypeName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '状态',
          key: 'statusName',
          tooltip: true,
          minWidth: 80,
        },
        {
          title: '商品编码',
          tooltip: true,
          key: 'serialCode',
          minWidth: 82,
        },
        {
          title: '通用名称',
          key: 'medicineInfoVoApprovedDrugNames',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '商品名称',
          tooltip: true,
          key: 'medicineInfoVoGoodsName',
          minWidth: 142,
        },
        {
          title: '规格',
          key: 'medicineInfoVoSpecifications',
          tooltip: true,
          minWidth: 130,
        },
        {
          title: '批准文号/注册证号',
          key: 'medicineInfoVoApprovalCode',
          tooltip: true,
          minWidth: 134,
        },
        {
          title: '储存条件',
          key: 'medicineInfoVoStorageConditions',
          tooltip: true,
          minWidth: 112,
        },
        {
          title: '是否DTP',
          key: 'isDtpName',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: 'GSP分类',
          tooltip: true,
          key: 'medicineInfoVoGspLabelNames',
          minWidth: 142,
        },
        {
          title: '生产厂家',
          key: 'medicineInfoVoManufacturer',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '拒收数量',
          key: 'rejectNum',
          tooltip: true,
          minWidth: 86,
        },
        {
          title: '包装单位',
          tooltip: true,
          key: 'medicineInfoVoDrugMinimumPackagingUnitString',
          minWidth: 82,
        },
        {
          title: '原验收/收货数量',
          key: 'receiveNum',
          tooltip: true,
          minWidth: 122,
        },
        {
          title: '原验收/收货单价',
          key: 'priceBeforeTax',
          tooltip: true,
          minWidth: 122,
        },
        {
          title: '供应商名称',
          key: 'supplierName',
          tooltip: true,
          minWidth: 142,
        },
      ],
      tableData: [],
      total: {},
    };
  },
  methods: {
    clear() {
      this.query = {
        storeIdList: [],
        gspIdList: [],
      };
    },
    getTotal() {
      const params = Object.assign({}, this.query);
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      purchase.getRejectionStatsSummary(params).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data;
        }
      });
    },
    handleExport() {
      const params = Object.assign({}, this.query);
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      purchase.rejectionStatsDownload(params)
        .then((res) => {
          if (res.data.error) {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getStorageConditionsList() {
      goodsService.GoodsDictionary({ dictionaryTypeEnum: 9 }).then((res) => {
        if (res.data.status === 200) {
          this.storageConditionsList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getGSPList() {
      goodsService.listGoodsLabels({ categoryId: 1 }).then((res) => {
        if (res.data.status === 200) {
          this.gspList = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      const params = Object.assign({}, this.query);
      params.page = this.page;
      params.size = this.size;
      // if (params.createTimeStart) {
      //   params.createTimeStart = (new Date(params.createTimeStart)).getTime();
      // }
      // if (params.createTimeEnd) {
      //   params.createTimeEnd = (new Date(params.createTimeEnd)).getTime();
      // }
      this.getTotal();
      purchase.rejectionStats(params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = utils.formatDate(result.createTime);
            console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getStorageConditionsList();
    this.getGSPList();
    this.handleSearch(true);
  },
};
</script>
